<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Recebimento Romaneio"
  [p-actions]=actions>
  <div class="po-row">
    <po-widget class="po-md-12"
      p-title="Informações do Romaneio"
      (p-setting)="clickInformacoes()">
      @if(apareceInformacoes){
        <div>
          <po-info class="po-md-3" p-label="Código" [p-value]="romaneio.CZ00COD"></po-info>
          <po-info class="po-md-3" p-label="Placa" [p-value]="romaneio.CZ00PLACA"></po-info>
          <po-info class="po-md-3" p-label="Usuário" [p-value]="romaneio.CZ00USER"></po-info>
          <po-info class="po-md-3" p-label="Nome Usuário" [p-value]="romaneio.CUSRNOME"></po-info>
          <po-info class="po-md-3" p-label="Local Origem" [p-value]="romaneio.CZ00ORIGEM"></po-info>
          <po-info class="po-md-3" p-label="Local Destino" [p-value]="romaneio.CZ00DESTIN"></po-info>
        </div>
      }
    </po-widget>
  </div>

  <po-radio-group
    class="po-md-12"
    name="pesagem"
    [(ngModel)]="pesagem"
    p-columns="3"
    p-label="Opções de Pesagem"
    [p-options]="[
      { label: 'Individual',    value: '1' },
      { label: 'Rateio',        value: '2' },
      { label: 'Replicar Peso', value: '3' }
    ]"
  >
  </po-radio-group>

  <po-input
    [p-auto-focus]="true"
    class="po-md-10"
    name="etiqueta"
    [(ngModel)]="etiqueta"
    p-label="Etiqueta"
    (keyup.enter)="biparEtiqueta(true)"
  ></po-input>
  <po-checkbox
    class="po-md-2 po-mt-4"
    name="imprimirEtiquetaCliente"
    [(ngModel)]="imprimirEtiquetaCliente"
    p-label="Etiqueta Automática"
    (p-change)="trocaEtiquetaAutomatica()"
  ></po-checkbox>

  <h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Etiquetas Pendentes Recebimento</h1>
  <div class="po-row">
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      p-spacing="small"
      [p-striped]="true"
      p-container="shadow"
      [p-actions]="tabelaPrincipalActions"
      [p-columns]="colunas"
      [p-selectable]="true"
      [p-items]="romaneio.items">
    </po-table>
  </div>
</po-page-default>

<po-modal #recebimentoModal p-title="Recebimento Item" [p-primary-action]="confirmarRecebimentoAction">

  <form #f="ngForm">
    <po-number
      class="po-md-3"
      name="NZ02PESO"
      [(ngModel)]="expedicaoRomaneioItem.NZ02PESO"
      p-label="Peso (*)"
      [p-min]="0.01"
      p-required
      [p-readonly]="zprPermissaoDigitarPeso.CZPRGENERI=='N' && !podeAtivarDigitacaoFam"
    ></po-number>
    <po-input
      class="po-md-3"
      p-label="Prateleira"
      name="CZ02PRAT"
      [(ngModel)]="expedicaoRomaneioItem.CZ02PRAT"
    ></po-input>
    <po-combo class="po-md-4"
      name="CZ02UR"
      p-label="UR"
      [(ngModel)]="expedicaoRomaneioItem.NZ05RECNO"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrromaneio/UR/listaCombo/{{expedicaoRomaneioItem.CB1COD}}"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-clean="true">
    </po-combo>
    <po-select
      class="po-md-2"
      name="CZ02INFORM"
      [(ngModel)]="expedicaoRomaneioItem.CZ02INFORM"
      p-label="T ou E (*)"
      [p-options]="varInformacao"
      [p-required]="true"
    ></po-select>
    <po-button class="po-md-3" p-kind="primary" p-label="Pesar" (p-click)="pesar()"></po-button>
    @if(podeAtivarDigitacao){
      <po-button class="po-md-9" p-kind="secondary" p-label="Ativar/Desativar Digitação do Peso" (p-click)="alteraPermissaoPesagem()"></po-button>
    }
  </form>
</po-modal>

<po-modal #recebimentoRateioModal p-title="Recebimento Rateio" [p-primary-action]="confirmarRecebimentoRateioAction">
  <po-container
    p-title="Etiquetas do Rateio"
    class="po-md-12"
  >
    <po-divider p-label="Etiquetas do Rateio"></po-divider>
    <po-table
      class="po-md-12"
      [p-columns]="colunasEtiquetasBipadas"
      [p-items]="etiquetasBipadas.items"
      [p-height]="200"
      p-spacing="small"
      [p-container]="true"
      [p-hide-table-search]="true"
    ></po-table>
  </po-container>

  @if(expedicaoRomaneioItem.CZ02LOTE != '') {
    
  <po-container
    p-title="Dados da etiqueta" 
    class="po-md-12 po-mt-2"
  >
    <po-divider p-label="Dados da Etiqueta {{expedicaoRomaneioItem.CZ02LOTE}}"></po-divider>
    <po-input
      class="po-md-4"
      p-label="Prateleira"
      name="CZ02PRAT"
      [(ngModel)]="expedicaoRomaneioItem.CZ02PRAT"
    ></po-input>
    <po-combo class="po-md-4"
      name="CZ02UR"
      p-label="UR"
      [(ngModel)]="expedicaoRomaneioItem.NZ05RECNO"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrromaneio/UR/listaCombo/{{expedicaoRomaneioItem.CB1COD}}"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-clean="true">
    </po-combo>
    <po-select
      class="po-md-4"
      name="CZ02INFORM"
      [(ngModel)]="expedicaoRomaneioItem.CZ02INFORM"
      p-label="T ou E (*)"
      [p-options]="varInformacao"
      [p-required]="true"
    ></po-select>
    
    <po-button class="po-sm-12 po-md-12 po-lg-12"
      p-label="Salvar"
      (p-click)="confirmarItemRateio()"
    ></po-button>
  </po-container>
  } @else {

  <po-container
    p-title="Nova etiqueta no rateio"
    class="po-md-12 po-mt-2"
  >
    <po-divider p-label="Nova etiqueta no rateio"></po-divider>
    <po-input
      [p-auto-focus]="true"
      class="po-md-12"
      name="etiquetaRateio"
      [(ngModel)]="etiquetaRateio"
      p-label="Etiqueta"
      (keyup.enter)="biparEtiqueta(false)"
    ></po-input>
  </po-container>

  <po-container
    p-title="Peso do Rateio" 
    class="po-md-12 po-mt-2"
  >
    <po-divider p-label="Peso do Rateio"></po-divider>
    <po-number
      class="po-md-3"
      name="pesoRateio"
      [(ngModel)]="pesoRateio"
      p-label="Peso Rateio (*)"
      [p-min]="0.01"
      p-required
      (p-change)="distribuirPesoRateio()"
      [p-readonly]="zprPermissaoDigitarPeso.CZPRGENERI=='N' && !podeAtivarDigitacaoFam"
    ></po-number>
    <po-button class="po-md-3 po-mt-4" p-kind="primary" p-label="Pesar" (p-click)="pesarRateio()"></po-button>
    @if(podeAtivarDigitacao){
      <po-button class="po-md-9" p-kind="secondary" p-label="Ativar/Desativar Digitação do Peso" (p-click)="alteraPermissaoPesagem()"></po-button>
    }
  </po-container>
  }
  
</po-modal>


<po-modal #impressaoEtiquetaModal p-title="Container" [p-primary-action]="gerarEtiquetaClienteAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-6"
      name="impressora"
      [(ngModel)]="impressora"
      p-label="Impressora"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="zprColumnsFilters"
      [p-field-format]="zprFieldFormaterFilters"
      [p-filter-service]="zprService"
      [p-advanced-filters]="zprAdvancedFilters"
      [p-literals]="{ modalTitle: 'Impressora' }"
      [p-required]="true"
      [p-auto-height]="true"
    ></po-lookup>
    <po-select
      class="po-md-6"
      name="nCopias"
      p-label="Nº Cópias"
      [(ngModel)]="nCopias"
      [p-options]="[
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
      ]"
    ></po-select>
  </form>
</po-modal>

<po-modal #modalAlteraUR p-title="Alterar UR" p-size="sm" p-hide-close="true">
  <form #f="ngForm">
    <po-combo class="po-md-12"
      name="urselecionada"
      p-label="UR"
      [(ngModel)]="URselecionada"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrromaneio/UR/listaCombo/{{dadosEtiqueta.CB1COD}}"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-clean="true">
    </po-combo>
  </form>
  <po-modal-footer>
    <po-button class="po-md-2"
      p-label="Cancelar"
      p-danger="true"
      p-icon="po-icon-close"
      (p-click)="fecharAlteraUR()">
    </po-button>
    <po-button class="po-md-2"
      p-label="Salvar"
      p-kind="primary"
      p-icon="po-icon-ok"
      (p-click)="salvarAlteraUR()">
    </po-button>
  </po-modal-footer>
</po-modal>
